import { SaveOutlined } from '@ant-design/icons';
import { Row } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import CSS from 'csstype';
import React from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import TranslateText from 'components/hoc/TranslateText';

interface ISaveButtonComponent {
    style?: CSS.Properties;
    modalText?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onClick?: (val: any) => void; // TODO: zbavit se any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onModalClose?: (val: any) => void; // TODO: zbavit se any
    id?: string;
}

/**
 * SaveButtonComponenta pouzita na volanie put requestov v formach (isin amlz)
 * @param props ISaveButtonComponent
 */
const SaveButtonComponent: React.FC<ISaveButtonComponent> = props => {
    const {
        modalText,
        onClick,
        onModalClose,
        id = 'saveBtn',
        style = {
            top: -106,
            right: 0,
            position: 'absolute',
            display: 'flex',
            flexDirection: 'column',
            zIndex: 200
        }
    } = props;

    return (
        <AnchorComponent id={id}>
            <div style={style} onClick={onClick}>
                <SaveOutlined
                    style={{
                        fontSize: 36,
                        backgroundColor: 'white',
                        borderRadius: '50%',
                        color: '#006866',
                        marginLeft: 10,
                        marginRight: 10
                    }}
                />
                <Paragraph
                    text={'ULOZIT'}
                    style={{
                        textAlign: 'center',
                        color: '#006866'
                    }}
                />
            </div>
            <Modal
                title={<TranslateText>{'ULOZENI_DAT'}</TranslateText>}
                open={!!modalText}
                onCancel={onModalClose}
                footer={null}
            >
                <Row>
                    <Paragraph text={modalText ? modalText : ''} />
                </Row>
                <Row>
                    <ButtonComponent
                        id="saveBtnZavritBtn"
                        style={{
                            marginTop: 20
                        }}
                        buttontext="ZAVRIT"
                        onClick={onModalClose}
                    />
                </Row>
            </Modal>
        </AnchorComponent>
    );
};

export default SaveButtonComponent;
